/**
 * @generated SignedSource<<8c7578a9ac45e85040abd119a24c9444>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RowDeal_useTikTokSoundsTotal$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly mostRecentStat: {
        readonly current: number;
        readonly percentChange: number | null;
        readonly previous: number | null;
      } | null;
      readonly name: string | null;
      readonly tiktokUrl: string;
    } | null;
  } | null>;
  readonly " $fragmentType": "RowDeal_useTikTokSoundsTotal";
};
export type RowDeal_useTikTokSoundsTotal$key = {
  readonly " $data"?: RowDeal_useTikTokSoundsTotal$data;
  readonly " $fragmentSpreads": FragmentRefs<"RowDeal_useTikTokSoundsTotal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RowDeal_useTikTokSoundsTotal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TikTokSoundNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TikTokSoundNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tiktokUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "StatWithDelta",
              "kind": "LinkedField",
              "name": "mostRecentStat",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "current",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "previous",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "percentChange",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TikTokSoundNodeConnection",
  "abstractKey": null
};

(node as any).hash = "8a250c24bbf9c6ef36d7abb5000e2b3b";

export default node;
